export class GetUserAction {
  public static readonly type = '[User] GetUserAction';
  constructor(public readonly id: string) {}
}
